export default "__VITE_ASSET__623e5eb0__"